<template>
    <div class="main">
        <template v-if="!loading">
            <template v-if="mode === 'Mobile'">
                <AppBar />
                <ModuleSwipe />
            </template>
            <div class="pc-container" v-if="mode === 'Pc'">
                <div class="pc-content">
                    <ViewDetails />
                    <QuestionCard />
                </div>
            </div>

            <van-popup
                position="bottom"
                get-container="body"
                :safe-area-inset-bottom="true"
                :duration="0.18"
                :closeable="true"
                v-model="showQuestionCard"
                @closed="onCloseQuestionCard"
                class="popup-question-card"
            >
                <QuestionCard />
            </van-popup>
        </template>
    </div>
</template>
<script>
import QuestionCard from './components/result/QuestionCard.vue'
import AppBar from './components/result/AppBar.vue'
import ModuleSwipe from './components/result/ModuleSwipe.vue'
import ViewDetails from './components/result/ViewDetails.vue'
import { getPaperInfo, getCollectionList, getAnalysis, getCommitAnswer } from '@/api/paperApi.js'
import { getPaperBlockQuestions } from '@/api/paperApi.js'
import { mapGetters } from 'vuex'

export default {
    components: { QuestionCard, AppBar, ModuleSwipe, ViewDetails },
    computed: {
        ...mapGetters(['userInfo']),
        complexTypes() {
            return this.$store.state.paperResult.complexTypes
        },
        questionCardState() {
            return this.$store.state.paperResult.questionCardState
        },
    },
    watch: {
        questionCardState: function () {
            this.showQuestionCard = this.questionCardState
        },
    },
    data() {
        return {
            loading: true,
            // Pc / Mobile
            mode: 'Pc',

            showQuestionCard: false,
        }
    },
    created() {
        this.mode = window.innerWidth > 900 ? 'Pc' : 'Mobile'
        this.onResize()
        window.onresize = this.onResize
        if (this.userInfo) {
            this.initPaperData()
        }
    },
    methods: {
        onCloseQuestionCard() {
            this.$store.dispatch('paperResult/setQuestionCardState', false)
        },
        onResize() {
            this.$store.dispatch('paperResult/setConfig', {
                clientWidth: document.documentElement.clientWidth,
                clientHeight: document.documentElement.clientHeight,
            })
            this.$store.dispatch('paperResult/setQuestionCardState', false)
            clearTimeout(this.resizeTimer)
            this.resizeTimer = setTimeout(() => {
                const newMode = window.innerWidth > 900 ? 'Pc' : 'Mobile'
                if (this.mode !== newMode) {
                    this.mode = newMode
                    window.location.reload()
                }
            }, 300)
        },
        initPaperData() {
            const _paperNo = this.$route.params.paperNo
            const _batchNo = this.$route.params.batchNo

            Promise.all([
                getPaperInfo({ paperNo: _paperNo }),
                getPaperBlockQuestions({ paperNo: _paperNo }),
                getAnalysis({ paperNo: _paperNo }),
                getCommitAnswer({ paperNo: _paperNo, batchNo: _batchNo }),
                getCollectionList({ type: 'COLLECT', paperNo: _paperNo }),
            ]).then((res) => {
                let index = 1
                // 题型处理
                res[1].data.forEach((mItem) => {
                    mItem.questions.forEach((item) => {
                        if (this.complexTypes.includes(item.type)) {
                            item.complexQuestion = true
                        }
                        if (!item.complexQuestion) {
                            item.indexNo = index
                            index = index + 1
                        }

                        if (item.complexQuestion && item.childQuestions) {
                            item.childQuestions.forEach((child) => {
                                child.indexNo = index
                                child.content = child.content || ''
                                index = index + 1
                            })
                            // 统一替换 item.content 中的序号
                            if (item.content) {
                                let matchIndex = 0
                                const regex = /[（(]\d+[）)]/g
                                item.content = item.content.replace(regex, (match) => {
                                    matchIndex++
                                    if (matchIndex <= item.childQuestions.length) {
                                        return `(${item.childQuestions[matchIndex - 1].indexNo})`
                                    }
                                    return match // 保持原样
                                })
                            }
                        }
                    })
                })
                this.$store.dispatch('paperResult/setPaperInfo', res[0].data)
                this.$store.dispatch('paperResult/setModuleList', res[1].data)

                const analysisMap = {}
                const userAnswerMap = {}
                res[2].data.forEach((item) => {
                    analysisMap[`q-${item.questionId}`] = item
                    userAnswerMap[`q-${item.questionId}`] = {}
                })
                this.$store.dispatch('paperResult/setQuestionAnalysisMap', analysisMap)

                res[3].data.forEach((item) => {
                    userAnswerMap[`q-${item.questionId}`] = item
                })

                this.$store.dispatch('paperResult/setUserAnswerMap', userAnswerMap)

                // 初始化收藏数据
                const collectionMap = {}
                res[4].data.forEach((item) => {
                    collectionMap[`q-${item.questionId}`] = true
                })
                this.$store.dispatch('paperResult/setCollectionMap', collectionMap)
                this.loading = false
                document.title = res[0].data.title
            })
        },
    },
}
</script>
<style>
html,
body {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
.main {
    width: 100%;
    height: 100%;
}
/* 试题默认样式 */
.question-item {
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    overflow-y: auto;
}
.question-title {
    font-size: 15px;
    color: #444;
    line-height: 1.8em;
}
.popup-question-card .question-card {
    max-height: 400px;
    height: 80vh;
}

.pc-container {
    background: #f5f5f5;
    height: 100vh;
    overflow-y: scroll;
}
.pc-content {
    max-width: 900px;
    margin: 20px auto;
    position: relative;
    display: flex;
}
.pc-container .view-container {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-right: 16px;
    flex-grow: 1;
}
.pc-container .question-card {
    position: sticky;
    top: 0;
    flex-shrink: 0;
    width: 240px;
    height: 90vh;
    max-height: 800px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.pc-container .question-card .question-status {
    margin-right: 0;
}

.pc-container .module-list {
    height: calc(100% - 70px);
}
.pc-container .module-list .module-container {
    gap: 16px;
}

.pc-container .view-container .result-report {
    height: auto;
}
</style>
